__turbopack_context__.v({
  "lesMillsLogoImg": "BrandMarks-module__RNCp8W__lesMillsLogoImg",
});
